import '../styles/ProductReviewsCard.css';

const ProductReviewsCard = ({name, price, image, index, review }) => {
    return ( 
        <div className="ProductReviewsCard">
            <img src={image} alt={'review ' + index } />
            <h5>{review}</h5>
            <span>{name}</span>
            <b>{price}</b>
        </div>
     );
}
 
export default ProductReviewsCard;